import type { ReactNode } from "react";

/** Small helpers for the repeated "chip" pills shown across the UI. */

export function Chip({ children, className = "chip" }: { children: ReactNode; className?: string }) {
  return <span className={className}>{children}</span>;
}

export function BenefitChip({ kind }: { kind?: string | null }) {
  const map: Record<string, [string, string]> = {
    loan:      ["chip chip-saffron", "Loan"],
    equity:    ["chip chip-emerald", "Equity"],
    subsidy:   ["chip chip-accent",  "Subsidy / Grant"],
    composite: ["chip chip-accent",  "Composite"],
    "in-kind": ["chip chip-slate",   "In-kind"],
    other:     ["chip chip-slate",   "Benefit"],
  };
  const [cls, label] = map[kind ?? "other"] ?? map.other;
  return <span className={cls}>{label}</span>;
}

export function LevelChip({ level }: { level?: string | null }) {
  if (!level) return null;
  const label = level[0].toUpperCase() + level.slice(1);
  return <span className={level === "central" ? "chip chip-saffron" : "chip"}>{label}</span>;
}

export function SourceChip({ source }: { source?: string | null }) {
  if (source === "ecosystem")      return <span className="chip chip-emerald">Incubator / Portal</span>;
  if (source === "state_missions") return <span className="chip chip-accent">State programme</span>;
  if (source === "x_feed")         return <span className="chip chip-amber">Announcement</span>;
  if (source === "google_grants")  return <span className="chip">Discovered</span>;
  return null;
}

export function Highlight({ text, query }: { text: string; query?: string }) {
  if (!text) return null;
  if (!query) return <>{text}</>;
  const terms = query.trim().split(/\s+/).filter(Boolean).map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  if (!terms.length) return <>{text}</>;
  const re = new RegExp(`(${terms.join("|")})`, "gi");
  const parts: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(re)) {
    if (m.index! > last) parts.push(text.slice(last, m.index!));
    parts.push(<mark key={m.index}>{m[0]}</mark>);
    last = m.index! + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts}</>;
}
